import { useMutation, useQueryClient } from '@tanstack/react-query';
import { completeRemittanceInstruction } from '../api/remittance-instructions.ts';
import { CompleteRemittanceInstructionRequest } from '../api/requests/complete-remittance-instruction-request.ts';

export default function useCreateRemittanceInstruction() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: CompleteRemittanceInstructionRequest) =>
      completeRemittanceInstruction(request.id, request.remittanceDateTime),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['confirmedBillings'] });
      queryClient.invalidateQueries({ queryKey: ['remittanceInstructions'] });
    },
  });
}
